import { baseAPIRequest } from 'utilities/http';

function postRecommendedItemTrack (data) {

	const url = '/api/recommendeditems/user/engagement/';
	return baseAPIRequest({
		url,
		data,
		params: { method: 'POST' }
	});

}

export default postRecommendedItemTrack;
